export default __webpack_public_path__ + "static/commercial-ampm--mobile@1x-d20e3d800c206b24d7e3d4ea514707a5.webp";